module.exports = "<ul>\n<li>✨ 发布CDN版本</li>\n</ul>\n";